import { CTA } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useOneFormContext } from 'src/feature-app';
import { useTrackingManager } from 'src/feature-app/hooks/use-tracking-manager';
import { ArrowUp } from 'src/icons-core-imports';
import { OneFormState } from 'src/types';

interface AnterioCTAProps {
	hidden?: boolean;
}

export const AnteriorCTA = (props: AnterioCTAProps) => {
	const { handlePreviousStep } = useOneFormContext();
	const trackingManager = useTrackingManager();
	const [isFirstScreen, setIsFirstScreen] = useState(true);
	const { formInfo, formData } = useSelector((state: OneFormState) => state);
	const { screenIndex, stepsHistory, multiStepScreenIndex } = formInfo;
	const { hidden } = props;
	const isCem = formData?.fields?.formName?.includes('cem');
	const previusStepIsFirstStep = formInfo.screenIndex == 1;

	useEffect(() => {
		if (stepsHistory && stepsHistory.length > 0 && !multiStepScreenIndex) {
			stepsHistory[0] === screenIndex
				? setIsFirstScreen(true)
				: setIsFirstScreen(false);
		} else {
			setIsFirstScreen(false);
		}
	}, [screenIndex, multiStepScreenIndex]);

	return isFirstScreen || hidden ? null : (
		<CTA
			onClick={e => {
				trackingManager.trackFormStepButtonClick({
					contentId: 'Anterior',
				});
				if (isCem && previusStepIsFirstStep) {
					window.location.replace(window.location.href); // evitar rerendering
				} else {
					handlePreviousStep(e);
				}
			}}
			tag="button"
			emphasis="secondary"
			size="small"
			icon={<ArrowUp variant="small" />}
		>
			Anterior
		</CTA>
	);
};
